import { Button, Stack, Typography } from "@material-ui/core";
import { useTranslation } from "react-i18next";
import { getFilteredEventsByType } from "utils/calendar/filters";
import useCalendar from "hooks/useCalendar";
import type { EventTaskTab } from "./CalendarTasksTabs";

type CalendarTasksToolbarProps = {
  currentTab: EventTaskTab;
  onMoveAllOverdueTasksToToday: () => Promise<void>;
};

export function CalendarTasksToolbar({
  currentTab,
  onMoveAllOverdueTasksToToday
}: CalendarTasksToolbarProps): JSX.Element {
  const { t: translate } = useTranslation();

  const { events } = useCalendar();

  const overdueEvents = getFilteredEventsByType(events, "overdue");

  const showPostponeButton = Boolean(currentTab === "overdue" && overdueEvents.length);

  return (
    <Stack sx={{ mx: 2 }} direction="row" gap={2} justifyContent="space-between">
      <Typography variant="h6">{translate(`calendarPage.tasks.tabs.${currentTab}`)}</Typography>
      {showPostponeButton && (
        <Button
          size="small"
          color="primary"
          variant="contained"
          onClick={onMoveAllOverdueTasksToToday}
        >
          {translate("calendarPage.control.moveToToday")}
        </Button>
      )}
    </Stack>
  );
}
